import React, { FunctionComponent } from 'react';
import { useLocale } from '../../../contexts/LocaleProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import DebouncedLoader from '../../common/DebouncedLoader';
import { IntlProvider } from 'react-intl';
import { Box } from '@mui/material';
import ReusableTabs from '../../common/ReusableTabs';

import * as styles from '../../productPage/tableComponents/ProductPage_style';
import BreadCrumbs from '../../common/BreadCrumbs';
import OverViewPage from './OverViewPage';
import { useApplicationsContent } from '../../../graphql/pimcore/modules/siteContent/hooks/useApplicationsContent';

const ElectronicApplicationPage: FunctionComponent = () => {
    const { loading, error, contentTree } = useApplicationsContent('TempSensingForElectronics');
    console.log('ElectronicApplicationPage contentTree:', contentTree);

    const { locale, messages } = useLocale();
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <DebouncedLoader loading={loading} delay={1000} size={40} centered>
            <IntlProvider locale={locale} key={locale} defaultLocale="en" messages={messages}>
                <Box
                    width="100%"
                    component="main"
                    sx={{
                        padding: 0,
                        flexGrow: 0,
                        p: 0,
                    }}
                >
                    <ReusableTabs
                        bannerImage={contentTree.pageTitleBackgroundImage.imageUrl}
                        bannerTitle={contentTree.pageTitle.content}
                        bannerDescription={contentTree.pageSubtitle.content}
                        tabLabels={Object.values(contentTree.tabs).map((tab) => tab.title.content)}
                        tabKeys={Object.values(contentTree.tabs).map((tab) => tab.title.key)}
                        tabContents={[
                            <OverViewPage key="overview" contentTree={contentTree} />,
                            // <JobPage cmsContent={contentTree.SearchJobs} />,
                        ]}
                        bannerFontStyle={styles.bannerFont}
                        subBannerFontStyle={styles.bannerFont2}
                        pageName={'TempSensingForElectronics'}
                        showTabs={true}
                        breadcrumbs={
                            <BreadCrumbs navigationPath="/Home/Applications/TempSensingForElectronics" />
                        }
                    />
                </Box>
            </IntlProvider>
        </DebouncedLoader>
    );
};

export default ElectronicApplicationPage;
